import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userType = localStorage.getItem("userType");

  if (!userType) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
